import styled, { css } from 'styled-components';
import { hexToRgbA } from 'utils/colors';

export const OverlaysRoot = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 5;
`;

/** 1px marker for intersection-based scroll fade detection. */
export const ScrollSentinel = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  pointer-events: none;
  visibility: hidden;
`;

export const FadeEdge = styled.div<{
  $side: 'top' | 'bottom';
  $visible: boolean;
}>`
  position: absolute;
  left: 0;
  right: 0;
  height: 24px;
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.28s ease;

  ${({ $side, theme }) =>
    $side === 'top'
      ? css`
          top: 0;
          background: linear-gradient(
            to bottom,
            ${theme.color.blackSqueeze} 0%,
            ${hexToRgbA(theme.color.blackSqueeze, 0.72)} 55%,
            transparent 100%
          );
          -webkit-backdrop-filter: blur(1.5px);
          backdrop-filter: blur(1.5px);
        `
      : css`
          bottom: 0;
          background: linear-gradient(
            to top,
            ${theme.color.blackSqueeze} 0%,
            ${hexToRgbA(theme.color.blackSqueeze, 0.72)} 55%,
            transparent 100%
          );
          -webkit-backdrop-filter: blur(1.5px);
          backdrop-filter: blur(1.5px);
        `}
`;
